export const isAppRunningInIframe = (): boolean => window.self !== window.top;

export const getWindowHeight = (): string =>
  isAppRunningInIframe() ? "965px" : "100vh";
